import { message } from 'antd';
import { Position } from 'deck.gl';
import { IMoodSpaceItem, IPolygonLayer } from '../../types/map';
import {
  ConvertHexToRGBA,
  DatasetColors,
  datasetTypeColors,
} from '../../utils/common';
import { axiosInstance } from '../Api';

const defineDatasetLineColor = (category?: string | null) => {
  if (!category) return;
  return datasetTypeColors[category];
};

export default class DownloadRequest {
  private endPoint = 'DownloadRequest';

  async getAllMoodSpaceDefinition(datasetIds: string[]) {
    try {
      const r = await axiosInstance.post(
        `/${this.endPoint}/GetAllMoodSpaceDefinition`,
        {
          datasetIdList: datasetIds,
        }
      );

      if (datasetIds.length !== r.data.MoodSpaces.length) {
        message.error(
          'GetAllMoodSpaceDefinition result format is not correct!'
        );
        return;
      }
      const datasetZones = new Array<IPolygonLayer>();

      for (let i = 0; i < datasetIds.length; i++) {
        const item: IMoodSpaceItem = r.data.MoodSpaces[i];

        const coordinates = new Array<Position>();
        item.moodSpaceDefinition.split(',').forEach((stringPoint: string) => {
          const point = stringPoint.split(' ').map((c: string) => {
            return parseFloat(c);
          });
          coordinates.push([point[0], point[1]]);
        });

        const color = defineDatasetLineColor(item.category);
        datasetZones.push({
          id: datasetIds[i],
          coordinates: coordinates,
          lineColor: ConvertHexToRGBA(
            color || DatasetColors[i % DatasetColors.length]
          ),

          color: [0, 0, 0, 0],
          category: item.category ?? undefined,
        });
      }

      return datasetZones;
    } catch (error) {
      message.error('GetAllMoodSpaceDefinition result format is not correct!');
      console.log(error);
    }
  }

  async getAllFWESpaceDefinition(datasetIds: string[]) {
    const r = await axiosInstance.post(
      `/${this.endPoint}/GetAllFweSpaceDefinition`,
      {
        datasetIdList: datasetIds,
      }
    );

    const domains = r.data.MoodSpaces;
    const keys = Object.keys(domains);
    const datasetZones = new Array<IPolygonLayer>();

    keys.forEach((key: string) => {
      const coordinates = new Array<Position>();
      const stringPoints = domains[key];
      stringPoints.forEach((stringPoint: string) => {
        const point = stringPoint.split(' ').map((c) => {
          return parseFloat(c);
        });
        coordinates.push([point[0], point[1]]);
      });
      datasetZones.push({
        id: key,
        coordinates: coordinates,
        lineColor: [188, 188, 35],
        color: [0, 0, 0, 0],
      });
    });
    return datasetZones;
  }
}
